import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
} from './member-attachment.action';
import { MemberAttachment } from './member-attachment.model';

export interface MemberAttachmentRecordsState {
    listData: any[];
    singleData: MemberAttachment;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: MemberAttachmentRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
};


export const memberAttachmentRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData: listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
);